module.exports = __webpack_public_path__ + "img/ps.287654cf.svg";